import { TRatiosCarterasDBModel } from "../types/CarteraRatioTypes"
import { parseIsoDate } from "@/utils/DateFormatter"

export type TDataSeries = [number, number]

type TMapRatiosToGraphProps = {
    ratios: TRatiosCarterasDBModel[];
}

export const MapRatiosToGraph = ({ ratios }: TMapRatiosToGraphProps): TDataSeries[] => {
    let dataRatios: TDataSeries[] = [];
    ratios.forEach((row: TRatiosCarterasDBModel) => {
        const parsedDate = parseIsoDate(row.dateCalculation);
        if(!parsedDate)
        {
            return;
        }

        const dateFormated = parsedDate.getTime();
        
        let value: number = row.valueCartera;
        if (row.ratio === 'linear_return' || row.ratio === 'volatility' || row.ratio === 'max_drawdown' || row.ratio === 'downside_deviation') {
            value = row.valueCartera * 100;
        };

        dataRatios.push([ dateFormated, value ])
    });
    return dataRatios
}

